var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListvehiclestep4Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.b{stroke:#8ac43d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-609 -1419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(609 1419)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(513 1051)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.725,0V3.045c0,2.58-2.4,4.665-5.355,4.665S0,5.625,0,3.045V0C0,2.58,2.4,4.41,5.37,4.41,8.325,4.41,10.725,2.565,10.725,0Z",
    transform: "translate(113.402 405.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.74,4.65a3.935,3.935,0,0,1-.57,2.04,5.512,5.512,0,0,1-4.8,2.37A5.547,5.547,0,0,1,.57,6.69,3.935,3.935,0,0,1,0,4.65,4.357,4.357,0,0,1,1.56,1.365,5.725,5.725,0,0,1,5.355,0a5.8,5.8,0,0,1,3.8,1.365A4.264,4.264,0,0,1,10.74,4.65Z",
    transform: "translate(113.385 396.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.725,4.665V8.79c0,2.58-2.4,4.41-5.355,4.41S0,11.355,0,8.79V4.665C0,2.085,2.4,0,5.37,0a5.8,5.8,0,0,1,3.8,1.365A4.388,4.388,0,0,1,10.725,4.665Z",
    transform: "translate(113.402 396.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.694,1.53V4.62a1.54,1.54,0,0,1-1.5,1.53H3.254a3.2,3.2,0,0,1-3.24-2.8A3.013,3.013,0,0,1,.914.9,2.99,2.99,0,0,1,3.074,0h3.12A1.54,1.54,0,0,1,7.694,1.53Z",
    transform: "translate(133.306 394.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,10.5v-3C0,3.42,2.46.57,6.285.09A7.983,7.983,0,0,1,7.5,0H21a6.859,6.859,0,0,1,1.125.075C25.995.525,28.5,3.39,28.5,7.5V9.675H25.38a3.091,3.091,0,0,0-3.06,3.345,3.2,3.2,0,0,0,3.24,2.8H28.5V18A7.086,7.086,0,0,1,21,25.5H17.25",
    transform: "translate(111 385.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H36V36H0Z",
    transform: "translate(144 416) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListvehiclestep4Icon);
export default __webpack_public_path__ + "static/media/listvehiclestep4icon.c4d62e3eb518045d2e75e0f3c389f23a.svg";
export { ForwardRef as ReactComponent };